import React, { useCallback } from "react";
import { Button, ButtonSize, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { useHistory } from "react-router-dom";
import { Task } from "../../config/tasks";
import * as adobeAnalytics from "../../utility/adobe-analytics";
import { IconExternalLink } from "@amzn/stencil-react-components/icons";

interface TaskActionProps {
  task: Task;
  applicationId: string;
  disabled?: boolean;
}

export const TaskAction = ({ task, applicationId, disabled }: TaskActionProps) => {
  const history = useHistory();

  const href = task.href as string;
  const { isLink, buttonText } = task;

  const track = useCallback(() => {
    if (!task.analyticsOnAction) {
      return;
    }
    adobeAnalytics.addPageLoadMetric(window, applicationId, task.analyticsOnAction);
  }, [applicationId, task.analyticsOnAction]);

  const navigateToUrl = useCallback(() => {
    track();
    href.startsWith("http") ? window.location.assign(href) : history.push(href);
  }, [history, href, track]);

  return isLink ? (
    <Link href={href} target="_blank" fontSize="T300" onClick={track}>
      <Row alignItems="center" gridGap="0.2rem" onClick={track}>
        <IconExternalLink />
        {buttonText}
      </Row>
    </Link>
  ) : (
    <Button size={ButtonSize.Small} variant={ButtonVariant.Primary} onClick={navigateToUrl} disabled={disabled}>
      <Row padding="0.2rem 1rem">{buttonText}</Row>
    </Button>
  );
};
